import 'css-chunksrc/feature/flip-and-tip/FlipAndTipLocationLogo.module.scss';export default {
  "root": "FlipAndTipLocationLogo_root",
  "has_image": "FlipAndTipLocationLogo_has_image"
};